import { api } from '~/services/api'

/**
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
export const apiGetListBusinessTravelNotCheckIn = (params) => {
  const uri = `/bussiness-roster-calendar/get-list-bussiness-trip-not-checkin`
  return api.get(uri, params)
}

